import EmptyStateNew from '../../../components/empty-state/EmptyStateNew';
import { useWorkpaperContext } from '../../../providers/WorkpaperProvider';
import { WorksheetTypeEnum } from '../../../types/worksheet';

type NoEntriesMessageProps = {
    type: WorksheetTypeEnum;
    onClick: () => void;
};

function NoEntriesMessage({ type, onClick }: NoEntriesMessageProps): JSX.Element {
    const { readOnly } = useWorkpaperContext();

    return (
        <div className="mt-16">
            {type === WorksheetTypeEnum.RECONCILIATION ? (
                <EmptyStateNew
                    actionText="New Entry"
                    helpLink="https://learn.cimplico.com/docs/worksheet-reconciling#creating-an-entry"
                    helpText="Reconcile the account by adding debit/credit entries."
                    title="Add your first entry"
                    onClick={onClick}
                    disableActionButton={readOnly}
                />
            ) : (
                <EmptyStateNew
                    actionText="New Entry"
                    helpLink="https://learn.cimplico.com/docs/other-schedules-overview#creating-an-entry"
                    helpText="Create a new entry to attach a schedule."
                    title="Add your first entry"
                    onClick={onClick}
                    disableActionButton={readOnly}
                />
            )}
        </div>
    );
}

export default NoEntriesMessage;
